import { AdminFeedbackCycle } from '~src/hooks/api/adminFeedback/types';
import useAdminFeedbackEntries from '~src/hooks/api/adminFeedback/useAdminFeedbackEntries';
import { CiSearch } from 'react-icons/ci';
import {
  CompletionTabContainer,
  FilterContainer,
  SearchContainer,
  StyledInput,
} from './CompletionTab.styled';
import FeedbackItem from './FeedbackItem/FeedbackItem';
import useRemindUsers from '~src/hooks/api/adminFeedback/useRemindUsers';
import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';
import { useDispatch } from 'react-redux';
import { showNotification } from '~src/store/app/actions';
import { useState } from 'react';
import SortSelector from '~src/shared/sortSelector/SortSelector';
import { completionTabSortOptions } from '~src/modules/reports/shared/constants/sortingOptions';
import { useDebounceValue } from 'usehooks-ts';
import LoadingSpinner from '~src/shared/loadingSpinner/LoadingSpinner';
import { MainContainerAnimation } from '~src/styles/animations';

interface CompletionTabProps {
  adminFeedbackCycle?: AdminFeedbackCycle;
}

const CompletionTab = ({ adminFeedbackCycle }: CompletionTabProps) => {
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSort, setSelectedSort] = useState('');
  const [debouncedSearchTerm] = useDebounceValue(searchTerm, 500);

  const { data, isLoading } = useAdminFeedbackEntries({
    id: adminFeedbackCycle?.id || '',
    sort: selectedSort,
    'filter.name': debouncedSearchTerm,
  });

  const { mutate: remindUsers, isPending } = useRemindUsers();

  const handleRemindUsers = () => {
    if (!adminFeedbackCycle?.id) {
      return;
    }

    remindUsers(adminFeedbackCycle.id, {
      onSuccess: () => {
        dispatch(
          showNotification({
            id: 'reminder-sent',
            txtKey: 'We have sent the reminder to all users.',
          }),
        );
      },
    });
  };

  return (
    <CompletionTabContainer>
      <FilterContainer>
        <SortSelector
          sortingOptions={completionTabSortOptions()}
          selectedSorting={selectedSort}
          sortList={setSelectedSort}
          selectorWithLabel
        />

        <SearchContainer>
          <StyledInput
            size="large"
            placeholder="Search employees"
            prefix={<CiSearch />}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <PrimaryButtonLoading isLoading={isPending} onClick={handleRemindUsers}>
            Send reminder to all
          </PrimaryButtonLoading>
        </SearchContainer>
      </FilterContainer>

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <MainContainerAnimation>
            {data?.map(item => <FeedbackItem key={item.id} data={item}/>)}
        </MainContainerAnimation>
      )}
    </CompletionTabContainer>
  );
};

export default CompletionTab;
